import React, { useEffect, useState } from "react";
import {
  Drawer,
  Box,
  Typography,
  IconButton,
  Button,
  useMediaQuery,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { darkTheme, lightTheme } from "../../../../theme/Theme";
import CloseIcon from "@mui/icons-material/Close";
import { useForm } from "react-hook-form";
import commonStyles from "../../../PotatoProtection/LargeScreen/Landing/addVariteyDrawerStyle";
import {
  setEditSlider,
  setFetchPending,
} from "../../../../slices/invitationSlice";

import AutoCompleteField from "../../../../utils/Fields/AutoComplete";
import TextInputField from "../../../../utils/Fields/TextInputField";

import { BASE_URL } from "../../../../constant/apiUrl";
import axios from "../../../../API/API";
import {
  showErrorToast,
  showSuccessToast,
} from "../../../../utils/Toast/toast";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import editrequestValidations from "./editrequestValidations";
import Loading from "../../../../utils/Loader";
const validationSchema = yup.object().shape({
  firstName: yup.string().required("Name is required"),

  email: yup
    .string()
    .email("Invalid email format")
    .required("Email address is required"),
  company: yup.string().required("Organization is required"),

  lastName: yup.string().required("Role is required"),
  country: yup.object().shape({
    id: yup.string().required("Country is required"), // Ensure country ID is selected
  }),
});
function EditRequestSlider({ actionData }) {
  const isDarkTheme = useSelector((state) => state.theme);
  const { editSlider } = useSelector((store) => store.invitation);
  const dispatch = useDispatch();
  const { fetch } = useSelector((state) => state.invitation);
  const [autoComplete, setAutoComplete] = useState(null);
  const isMobile = useMediaQuery("(max-width:600px)");
  const [loading, setLoading] = useState(false);
  const {
    register,
    handleSubmit,
    formState,
    reset,
    setValue,
    getValues,
    clearErrors,
    setError,
  } = useForm({
    resolver: yupResolver(validationSchema),
  });
  const { errors } = formState;
  const { countryFilter } = useSelector((store) => store.internalFilter);
  const onFieldChange = (field, value) => {
    setValue(field, value); // Update the field value
    const validationErrors = editrequestValidations(
      getValues("firstName"),
      getValues("lastName"),
      getValues("email"),
      getValues("company"),
      getValues("country")
    );

    if (validationErrors[field]) {
      setError(field, { type: "manual", message: validationErrors[field] });
    } else {
      clearErrors(field); // Clear the error if validation passes
    }
  };

  // Auto-populate form with actionData values
  useEffect(() => {
    if (actionData) {
      reset({
        firstName: actionData.firstName || "",
        lastName: actionData.lastName || "",
        email: actionData.email || "",
        company: actionData.company || "",
        country: actionData.country || "",
        sponsorEmail: actionData.sponsorEmail || "",
        providedCountry: actionData.providedCountry || "",
      });

      // Set the country auto-complete field (if countryData is available)
      const country = countryFilter?.find(
        (item) => item.id === actionData.countryId
      );
      if (country) {
        setAutoComplete(country.id);
        setValue("country", country); // Populate country in the form
      }
    } else {
      reset({
        firstName: "",
        lastName: "",
        company: "",
        country: "",
        email: "",
        sponsorEmail: "",
        providedCountry: "",
      });
    }
  }, [actionData, countryFilter, reset, setValue, editSlider]);

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      const newData = {
        ...data,
        countryId: autoComplete === null ? actionData.countryId : autoComplete,
      };

      const response = await axios.put(
        `${BASE_URL}/admin/access-request-form/update/${actionData?.id}`,
        newData
      );
      if (response?.status === 200) {
        showSuccessToast(
          "You have successfully updated the request information "
        );
        dispatch(setFetchPending(!fetch));
        dispatch(setEditSlider(false));
      }
    } catch (e) {
      console.log(e, "error");

      showErrorToast("An error ocurred please try again ");
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    dispatch(setEditSlider(false));
  };

  return (
    <Drawer
      anchor={isMobile ? "bottom" : "right"}
      open={editSlider}
      PaperProps={{
        sx: {
          height: isMobile ? "90%" : "100%",
          width: isMobile ? "100%" : 436,
          padding: "16px 24px",
          display: "flex",
          flexDirection: "column",
          gap: "16px",
          background: isDarkTheme
            ? darkTheme.backgroundColorLayer3
            : "var(--color-background-layer-01)",
        },
      }}
      ModalProps={{
        BackdropProps: {
          sx: {
            backgroundColor: isDarkTheme
              ? darkTheme.drawerOverlayColorLayer1
              : lightTheme.drawerOverlayColorLayer1,
          },
        },
      }}
    >
      {loading && <Loading />}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "var(--Spacing-spacing-8, 8px)",
        }}
      >
        <Typography
          variant="h6"
          sx={{
            color: isDarkTheme && darkTheme.textColorLayer1,
            fontSize: "var(--Font-Size-H6, 18px)",
            fontWeight: 700,
            lineHeight: "var(--Line-Height-H6, 28px)",
            fontFamily: "var(--Typography-Font-Family-Heading, Inter)",
          }}
        >
          Edit request information
        </Typography>
        <IconButton onClick={handleClose} data-testid="close-button">
          <CloseIcon
            style={{
              color: isDarkTheme ? darkTheme.iconColor1 : lightTheme.iconColor1,
            }}
          />
        </IconButton>
      </Box>

      <form
        className="w-full flex flex-col gap-3 h-full"
        onSubmit={handleSubmit(onSubmit)}
      >
        <Box
          sx={{
            ...commonStyles.container,
            flex: 1,
            padding: "var(--Spacing-spacing-16, 16px)",
            backgroundColor: isDarkTheme
              ? darkTheme.backgroundColorLayer1
              : lightTheme.backgroundColorLayer1,
            overflowY: "auto",
          }}
        >
          {/* Variety Input */}
          <TextInputField
            label="First name"
            name="firstName"
            required={true}
            errors={errors}
            width1="100%"
            register={register}
            width="100%"
            onChange={(e) => onFieldChange("firstName", e.target.value)}
            datatestid="text-input-first-name"
          />

          <TextInputField
            label="Last name"
            name="lastName"
            required={true}
            errors={errors}
            width1="100%"
            register={register}
            width="100%"
            onChange={(e) => onFieldChange("lastName", e.target.value)}
            datatestid="text-input-last-name"
          />
          <TextInputField
            label="Email"
            name="email"
            errors={errors}
            required={true}
            width1="100%"
            register={register}
            width="100%"
            type="email"
            onChange={(e) => onFieldChange("email", e.target.value)}
            datatestid="text-input-email-address"
          />
          <TextInputField
            label="Company/Organistation"
            name="company"
            errors={errors}
            required={true}
            width1="100%"
            register={register}
            width="100%"
            onChange={(e) => onFieldChange("company", e.target.value)}
            datatestid="text-input-organisation"
          />

          <AutoCompleteField
            key={autoComplete}
            label="Country"
            options={countryFilter?.map((item) => ({
              label: item.name,
              id: item.id,
            }))} // Ensure `options` contain both `label` and `id`.
            getOptionLabel={(option) => option.label || ""} // Ensure the displayed label is correct.
            name="country"
            placeholder="Select"
            isMobile={false}
            errors={errors}
            datatestid="text-input-country"
            register={register}
            onChange={(newValue) => {
              setAutoComplete(newValue.id); // Set the country ID
              setValue("country", { id: newValue.id, label: newValue.label });
              clearErrors("country");
            }}
            required={true}
            value={
              autoComplete
                ? {
                    id: autoComplete,
                    label: countryFilter.find(
                      (item) => item.id === autoComplete
                    )?.name,
                  }
                : null
            } // Auto-select the country based on the state
            width1={"356px"}
            width="100%"
          />

          <TextInputField
            label="Sponsor's Email"
            name="sponsorEmail"
            errors={errors}
            width1="100%"
            register={register}
            width="100%"
            type="email"
            datatestid="text-input-pepsico-email"
          />
        </Box>

        {/* Button Section */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "16px",
            // backgroundColor: isDarkTheme
            //   ? darkTheme.backgroundColorLayer3
            //   : "var(--color-background-layer-01)",
            boxShadow: "0px 1px 0px 0px #DFDFDF inset",
            p: "24px",
          }}
        >
          <Button
            variant="outlined"
            sx={{
              ...commonStyles.buttonBase,
              ...commonStyles.outlinedButton,
            }}
            type="button"
            onClick={handleClose}
            data-testid="cancel-button"
          >
            <Typography sx={commonStyles.typographyButton}>Cancel</Typography>
          </Button>

          <Button
            variant="contained"
            sx={{
              ...commonStyles.buttonBase,
              ...commonStyles.containedButton,
            }}
            data-testid="submit-button"
            type="submit"
          >
            <Typography sx={commonStyles.typographyButton}>Save</Typography>
          </Button>
        </Box>
      </form>
    </Drawer>
  );
}

export default React.memo(EditRequestSlider);
